<template>
  <div class="window-contain">
    <div class="window">
      <!-- Header -->
      <header class="window-header">
        <the-window-header :isStatus="isStatus" :open="open" @handleNotice="handlenotice"></the-window-header>
      </header>

      <section class="window-content">
        <!-- Aside Left -->
        <aside class="window-aside--left">
          <the-window-aside-left :kefu_id="userInfo.user_id" :current="thread_id" @change="changeSession" ref="user"></the-window-aside-left>
        </aside>

        <!-- Main -->
        <main class="window-main">
          <the-window-main :to-id="sessionID" :avatar="user_avatar" :from-id="userInfo.id" :chat-type="type" :thread_id="thread_id" ref="chat"></the-window-main>
        </main>

        <!-- Aside Right -->
        <aside class="window-aside--right">
          <the-window-aside-right :to-id="sessionID" :chat-type="type"></the-window-aside-right>
        </aside>
      </section>
    </div>
    <div class="quick-reply" :style="{height:show?'auto':'40px'}">
      <div class="title">
        <el-tooltip :content="!show?'展开':'收起'" placement="top" effect="dark" >
          <i v-if="show" class="el-icon-caret-bottom" @click="show=!show"></i>
          <i v-else @click="show=!show" class="el-icon-caret-right"></i>
        </el-tooltip>
        客服快捷语回复
      </div>
      <div class="lists">
        <quick-reply></quick-reply>
      </div>
    </div>
    <!-- 获取声音提示弹框 -->
    <el-dialog width="20%" :visible="showDialog" :show-close="false">
      是否允许开启音效
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">拒 绝</el-button>
        <el-button type="primary" @click="handlevisible">同 意</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TheWindowHeader from "./components/TheWindowHeader";
import TheWindowMain from "./components/TheWindowMain";
import TheWindowAsideLeft from "./components/TheWindowAsideLeft";
import TheWindowAsideRight from "./components/TheWindowAsideRight";
import {mapGetters, mapActions} from "vuex";
import net from "../../utils/net";
import QuickReply from "./components/QuickReply.vue";
export default {
  name: "Window",

  components: {
    QuickReply,
    TheWindowHeader,
    TheWindowAsideLeft,
    TheWindowAsideRight,
    TheWindowMain,
  },

  data() {
    return {
      sessionID: "",
      type: "private",
      thread_id: 0,
      isStatus: false,
      user_avatar: "",
      //提示音相关
      open: false,
      ring: false,
      //收到消息提示音
      notice: require("@/assets/notice.mp3"),
      audioSrc: '@/assets/tip.mp3',
      showDialog: false,
      userInfo:{},
      show:true
    };
  },

  methods: {
    ...mapActions('music', ['handleVisible']),

    handlenotice() {
      this.open = !this.open;
      this.handleVisible(this.open)
      this.$net.tipVoice = this.open;
    },

    /**
     * 开启声音
     */
    handlevisible() {
      this.open = true; // ① 开启组件
      this.handleVisible(true)
      this.showDialog = false;
      this.$net.tipVoice = true;
    },

    //刷新会话
    refreshSession() {
      let tempsessionID = this.sessionID;
      let temptype = this.type;
      let tempthread_id = this.thread_id;
      let tempuser_avatar = this.user_avatar;
      this.changeSessionNull;
      this.changeSession(tempsessionID,temptype,tempthread_id,tempuser_avatar)
    },

    //切换会话
    changeSession(userID, type, thread_id, avatar) {
      this.sessionID = userID;
      this.type = type;
      this.thread_id = thread_id;
      this.user_avatar = avatar;
    },

    //切换会话清空
    changeSessionNull(userID, type, thread_id, avatar) {
      this.sessionID = null;
      this.type = null;
      this.thread_id = null;
      this.user_avatar = null;
    },
  },

  //vue3依赖注入 父组件提供方法给后代使用
  provide() {
    return {
      sendMessage: this.sendMessage,
      send: this.send,
      refreshSession:this.refreshSession
    };
  },

  async created() {
    this.$event.$on('refreshKefu', this.changeSessionNull)
  },

  async mounted() {
    await this.$net.init();
    this.userInfo = this.$net.userInfo;
    this.showDialog = true;
  },


};
</script>

<style lang="scss" scoped>
.window-contain {
  $--window-width: 1240px;
  $--window-height: 100%;
  $--window-header-height: 100px;
  $--window-aside-l-width: 240px;
  $--window-aside-r-width: 300px;

  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 60px;
  width: 100vw;
  //min-height: 800px;
  //min-width: 1200px;

  .window {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    width: $--window-width;
    height: $--window-height;
    min-height: 500px;
    min-width: 800px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    background-color: #ffffff;

    &-header {
      height: $--window-header-height;
    }

    &-content {
      flex: 1;
      display: flex;
      flex-direction: row;

      .window-aside {
        &--left {
          width: $--window-aside-l-width;
          border-right: 1px solid $--border-color-base;
        }

        &--right {
          width: $--window-aside-r-width;
          border-left: 1px solid $--border-color-base;
        }
      }

      .window-main {
        flex: 1;
      }
    }
  }
  .quick-reply{
    overflow: hidden;
    transition: height ease 0.3s;
    background: #fff;
    height:800px;
    width:330px;
    position: absolute;
    right:0;
    top:40px;
    .title{
      padding: 20px;
      font-size: 18px;
      border-bottom: 2px solid #eee;
    }
    .lists{
      position: relative;
      padding: 5px;
    }
  }
}
</style>
